var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "pb-2"
  }, [_c('BRow', {
    staticClass: "mb-1"
  }, [_c('BCol', {
    staticClass: "px-50"
  }, [_c('ClassBookingProSearch')], 1)], 1), _c('BRow', [_c('BCol', {
    staticClass: "px-50",
    attrs: {
      "cols": "12",
      "md": "7"
    }
  }, [_c('ClassBookingProTrip')], 1), _c('BCol', {
    class: "px-50 ".concat(_vm.isMobileView ? 'mt-1' : ''),
    attrs: {
      "cols": "12",
      "md": "5"
    }
  }, [_c('ClassBookingProBook')], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }